export default __webpack_public_path__ + "static/code-we-23ce38eafae95653156f81cfe7ea7679.jpg";